// extracted by mini-css-extract-plugin
export default {"wrapper":"W_SelectItem_wrapper__gCb64","list_wrapper":"W_SelectItem_list_wrapper__qfNzg"};